import React from 'react';
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';
import {
  DatePickerProps as MuiDatePickerProps,
  DatePicker as MuiDatePicker,
} from '@mui/x-date-pickers';

import { useCanEditFormFieldsContext } from '@occc-app/App/CanEditFormFieldsContext';

import { ShowErrorFunc, showErrorOnChange } from './rff/Util';

interface DatePickerWrapperProps extends FieldRenderProps<MuiDatePickerProps<Date>> {
  required?: boolean;
  locale?: any;
}

const DatePickerWrapper = (props: DatePickerWrapperProps) => {
  const {
    input: { name, onChange, value, ...restInput },
    meta,
    locale,
    required,
    showError = showErrorOnChange,
    ...rest
  } = props;

  const { error, submitError } = meta;
  const isError = showError({ meta });

  const { helperText, ...lessrest } = rest;

  return (
    <MuiDatePicker
      onChange={onChange}
      value={value || null}
      slotProps={{
        textField: {
          name,
          required,
          fullWidth: true,
          helperText: isError ? error || submitError : helperText,
          error: isError,
          inputProps: {
            onBlur: restInput.onBlur,
            onFocus: restInput.onFocus,
          },
        },
      }}
      {...lessrest}
    />
  );
};

export interface DatePickerProps extends Partial<Omit<MuiDatePickerProps<Date>, 'onChange'>> {
  name: string;
  locale?: any;
  fieldProps?: Partial<FieldProps<any, any>>;
  required?: boolean;
  showError?: ShowErrorFunc;
}

export const KeyboardDatePicker = (props: DatePickerProps) => {
  const { isEditable } = useCanEditFormFieldsContext();
  const { name, fieldProps, required, disabled, ...rest } = props;
  const isDisabled = disabled || !isEditable;

  return (
    <Field
      name={name}
      disabled={isDisabled}
      render={(fieldRenderProps) => (
        <DatePickerWrapper required={required} {...fieldRenderProps} {...rest} />
      )}
      {...fieldProps}
    />
  );
};
